import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Thai from './locales/th/translations';
import English from './locales/en/translations';

// the translations
// (tip move them in a JSON file and import them)
const resources = {
  en: {
    translation: English
  },
  th: {
    translation: Thai
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    react: {
      useSuspense: false
    },

    resources,
    lng: "th",
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
